import { Action, createReducer, on } from '@ngrx/store';
import { FavouriteItemState } from './favourite-item.state';
import { AddFavouriteItemAction, AddFavouriteItemSuccessAction, ClearFavoriteItemsAction, GetFavouriteLocationsSuccessAction, GetFavouriteVouchersSuccessAction, GetFavouriteWalletsSuccessAction, LimitReachedFavouriteItemAction, RemoveFavouriteItemAction, RemoveFavouriteItemSuccessAction, setAccountID } from './favourite-item.actions';

const FAVORITE_LIMIT = 3; // Limit for favorite items
const initialState = new FavouriteItemState();

const reducer = createReducer(
  initialState,

  on(AddFavouriteItemAction, (state) => {
    return {
      ...state,
      isLoading: true, // Set loading state to true when adding favorite item
    };
  }),
  
  on(AddFavouriteItemSuccessAction, (state, { itemType, updatedFavoriteItems }) => {
    return {
      ...state,
      isLoading: false, // Reset loading state after success
      favoriteItems: {
        ...state.favoriteItems,
        accountID: state.accountID, // Ensure accountID remains in the state
        [itemType]: updatedFavoriteItems, // Update favorite items for the specific type
      },
      limitsReached: {
        ...state.limitsReached,
        [itemType]: updatedFavoriteItems.length >= FAVORITE_LIMIT, // Check and update limit for this itemType
      },
    };
  }),
  
  on(RemoveFavouriteItemAction, (state) => {
    return {
      ...state,
      isLoading: true, // Set loading state to true when removing favorite item
    };
  }),
  
  on(RemoveFavouriteItemSuccessAction, (state, { itemType, updatedFavoriteItems }) => {
    return {
      ...state,
      isLoading: false, // Reset loading state after removal success
      favoriteItems: {
        ...state.favoriteItems,
        [itemType]: updatedFavoriteItems, // Update favorite items for the specific type
      },
      limitsReached: {
        ...state.limitsReached,
        [itemType]: updatedFavoriteItems.length >= FAVORITE_LIMIT, // Check and update limit after removal
      },
    };
  }),
  
  on(LimitReachedFavouriteItemAction, (state, { itemType }) => {
    return {
      ...state,
      limitsReached: {
        ...state.limitsReached,
        [itemType]: true,
      },
    };
  }),
  

  on(ClearFavoriteItemsAction, (state) => ({
    ...state,
    favoriteItems: {
      wallet: [],
      voucher: [],
      location: [],
      clickAndCollect: [],
      accountID: null,
    },
    limitsReached: {
      wallet: false,
      voucher: false,
      location: false,
      clickAndCollect: false,
    },
    isLoading: false,
  })),

on(setAccountID, (state, { accountID }) => {
  const newState = { ...state };
  newState.isLoading = false;
  newState.accountID = accountID;
  return newState;
}),

on(GetFavouriteLocationsSuccessAction, (state, { locations }) => {
  const newState = { ...state };
  newState.isLoading = false;
  newState.locations = locations;
  return newState;
}),
on(GetFavouriteVouchersSuccessAction, (state, { vouchers }) => {
  const newState = { ...state };
  newState.isLoading = false;
  newState.vouchers = vouchers;
  return newState;
}),
on(GetFavouriteWalletsSuccessAction, (state, { wallets }) => {
  const newState = { ...state };
  newState.isLoading = false;
  newState.wallets = wallets;
  return newState;
}),
);

export function FavouriteItemReducer(state: FavouriteItemState | null, action: Action) {
  return reducer(state, action);
}
